// deps
import * as React from "react";

// internal deps
import { OnPayExtraParams } from "@swiggy-private/payment-types";
import { useMountedRef } from "@swiggy-private/core-ui";
import { Some } from "@swiggy-private/js-fp";
import { TransactionContext } from "@payment-client/contexts/TransactionContext";
import { CreateTransactionData } from "@payment-client/interfaces/TxnApi";

type OnPay = (txnData: CreateTransactionData) => void;

export const useOnProcess = (): OnPay => {
    const isMountedRef = useMountedRef();
    const { processingTransaction, doCreateTxn } = React.useContext(TransactionContext);

    const onProcess = React.useCallback<OnPay>(
        ({
            cardDetails,
            paymentMethod,
            isNonSecureCard,
            extraParams: params,
        }: CreateTransactionData): void => {
            if (!isMountedRef.current || processingTransaction) {
                return;
            }

            const extraParams: OnPayExtraParams = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                transaction_amount: 2,
                ...Some(params).unwrapOr({}),
            };

            doCreateTxn({ cardDetails, paymentMethod, extraParams, isNonSecureCard });
        },
        [isMountedRef, processingTransaction, doCreateTxn],
    );

    return onProcess;
};
